import { useMemo } from 'react';
import { UiIconName } from '@cbhq/cds-icons';
import { Icon } from '@cbhq/cds-web/icons';
import { Box } from '@cbhq/cds-web/layout';

type BorderedStepNumberProps = {
  stepNumber: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
};
export function BorderedStepNumber({ stepNumber }: BorderedStepNumberProps) {
  const iconName = `step${stepNumber}` as UiIconName;
  const stepNumberBorderStyle = useMemo(() => ({ borderWidth: '2px' }), []);
  return (
    <Box
      spacing={1}
      bordered
      borderRadius="roundedFull"
      borderColor="line"
      style={stepNumberBorderStyle}
      height={32}
      width={32}
    >
      <Icon name={iconName} size="s" color="foreground" />
    </Box>
  );
}
